require('./mixins/lodash');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import PrimeVue from 'primevue/config';
import ToastService from "primevue/toastservice";
import pl from './Locales/pl.json';
import en from './Locales/en.json';
import { createI18n } from 'vue-i18n';
import { Inertia } from '@inertiajs/inertia'
import { createGtm } from '@gtm-support/vue-gtm';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

Inertia.on('navigate', (event) => {
    if (typeof window.gtag === 'function') {
        gtag('event', 'page_view', {
            'page_location': event.detail.page.url
        });
    }
})

const i18n = createI18n({
    locale: 'pl',
    messages: {
        en: en,
        pl: pl
    }
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(PrimeVue)
            .use(i18n)
            .use(ToastService)
            .use(
                createGtm({
                    id: process.env.MIX_GTM_ID,
                    defer: false,
                    enabled: true,
                    debug: false,
                    loadScript: true,
                    trackOnNextTick: false,
                }),
            )
            .mixin({ methods: { route } })
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });
